import { render } from "./PersonManager.vue?vue&type=template&id=358ac592&scoped=true"
import script from "./PersonManager.vue?vue&type=script&lang=js"
export * from "./PersonManager.vue?vue&type=script&lang=js"

import "./PersonManager.vue?vue&type=style&index=0&id=358ac592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358ac592"]])

export default __exports__